import { type ElementType, type PropsWithChildren, forwardRef } from "react";
import classes from "./DDSMicroText.module.css";

export type DDSMicroTextProps = {
  as?: "span" | "p";
  className?: string;
  "data-name"?: string;
  /** Hover-only tooltip; keyboard and touch users never see it, so don't put essential information here. */
  title?: string;
};

export const DDSMicroText = forwardRef<HTMLElement, PropsWithChildren<DDSMicroTextProps>>(
  ({ as: tagName = "span", className, children, "data-name": dataName, title }, ref) => {
    const Tag = tagName as ElementType;
    const classNames = [className, classes.micro].filter((c) => !!c);
    return (
      <Tag ref={ref} className={classNames.join(" ")} data-name={dataName} title={title}>
        {children}
      </Tag>
    );
  },
);

DDSMicroText.displayName = "DDSMicroText";
